import React from "react";
import { Button, Modal } from "antd";
import "./function.css";
import { Vehicle } from "../../api";

export default function Function5({ machineID, data, setStatus, machineInfo }) {
  const { IP, port, name } = machineInfo;

  const switchOnConfirm = () =>
    Modal.confirm({
      title: `確認執行`,
      content: `確認開啟天車 ${name} `,
      onOk: async () => {
        await Vehicle.On(IP, port, machineID);
        setStatus(1);
      },
    });
  const switchOffConfirm = () =>
    Modal.confirm({
      title: `確認執行`,
      content: `確認關閉天車 ${name} `,
      onOk: async () => {
        await Vehicle.Off(IP, port, machineID);
        setStatus(0);
      },
    });
  return (
    <React.Fragment>
      <td>
        <div className="d-flex justify-content-center my-1">
          <div>
            <Button style={{ width: 80 }} className="mr-3" onClick={switchOnConfirm} disabled={data.status === -1}>
              ON
            </Button>
            <Button style={{ width: 80 }} onClick={switchOffConfirm} disabled={data.status === -1}>
              OFF
            </Button>
          </div>
        </div>
      </td>
    </React.Fragment>
  );
}
